<script setup lang="ts">
import IdentityHighlights from "./IdentityHighlights.vue";
import type { ResultDefinition } from "../types";

defineProps<{
  definition: ResultDefinition;
}>();
</script>

<template>
  <article class="identity-hero">
    <div class="identity-hero__copy">
      <div class="identity-hero__title-row">
        <h1>我是<span>{{ definition.name }}</span></h1>
        <div class="identity-hero__level">
          <small>班味浓度</small>
          <strong>{{ definition.banweiLabel }}</strong>
        </div>
      </div>
      <p class="identity-hero__headline">{{ definition.headline }}</p>
    </div>

    <div class="identity-hero__visual-frame" aria-hidden="true">
      <img
        class="identity-hero__visual"
        :class="`identity-hero__visual--${definition.code.toLowerCase()}`"
        :src="definition.poster.image"
        alt=""
      />
    </div>

    <slot name="after-visual" />
    <IdentityHighlights :highlights="definition.highlights" />
    <blockquote>{{ definition.shareText }}</blockquote>
    <slot name="footer" />
  </article>
</template>
